// Google Analytics Event Tracking Utilities

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// Track generic events
export const trackEvent = (eventName, parameters = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', eventName, parameters);
  }
};

// Track contact events
export const trackContactEvent = (contactType, contactValue) => {
  trackEvent('contact_click', {
    contact_type: contactType,
    contact_value: contactValue,
    event_category: 'engagement',
    event_label: contactType
  });
};

// Track form submission
export const trackFormSubmission = (formType, projectType = '') => {
  trackEvent('generate_lead', {
    form_type: formType,
    project_type: projectType,
    event_category: 'conversion',
    value: 1
  });
};

// Track page views (for single page apps)
export const trackPageView = (pagePath, pageTitle) => {
  if (isGtagAvailable()) {
    window.gtag('config', 'G-C58R41BV8T', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

// Track project views
export const trackProjectView = (projectTitle, projectCategory) => {
  trackEvent('view_item', {
    item_name: projectTitle,
    item_category: projectCategory,
    event_category: 'engagement'
  });
};

// Track scroll depth
export const trackScrollDepth = (percentage) => {
  trackEvent('scroll', {
    percent_scrolled: percentage,
    event_category: 'engagement'
  });
};

// Track file downloads
export const trackDownload = (fileName) => {
  trackEvent('file_download', {
    file_name: fileName,
    event_category: 'engagement'
  });
};

// Track external links
export const trackExternalLink = (url) => {
  trackEvent('click', {
    link_url: url,
    outbound: true,
    event_category: 'engagement'
  });
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  trackEvent('social_click', {
    social_platform: platform,
    event_category: 'engagement'
  });
}; 